import React, { PureComponent } from 'react'
import { Panel, Glyphicon, Button } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import SimpleTablePage from '../../../../containers/commons/general/SimpleTablePage'
import { compareValues } from '../../../../util/utils'
import DocumentDetailsFleetModalPage from '../../../../containers/management/fleets/auxModals/DocumentDetailsFleetModalPage'
import { fleetMode } from '../../../../constants/dossier/common/documentEditionModal'
import { documentEntityType as documentEntityTypeConstants } from '../../../../constants/dossier/common/documentEntityType'
import { permissions } from '../../../../constants/backendIds'
import { dossierTypesId as dossierTypeIdsConstant } from '../../../../constants/dossier/common/dossierTypes'
import { fleetsTab } from '../../../../constants/management/fleets'
import InputSelect from '../../../../components/commons/form/InputSelect'

class DocumentsListComponent extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      openDocumentPanel: false,
      dossiers: [],
      numDossiers: 0,
      filters: {
        orderBy: '+description',
        selectedCheck_massive: false
      }
    }
    this.dossierTypeOptions = [dossierTypeIdsConstant.sales, dossierTypeIdsConstant.paperwork, dossierTypeIdsConstant.purchase]
  }

  componentDidMount (prevProps, prevState) {
    this.updateList(this.props.dossierTypeSelected)
    this.props.change('dossierSubType', this.props.dossierTypeSelected)
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.props.tabActiveKey !== prevProps.tabActiveKey && this.props.tabActiveKey === fleetsTab.FLEETS_DOCUMENTS) {
      let dossiers = this.props.dossiers.length > 0 ? this.props.dossiers : this.state.dossiers
      if (this.props.dossiers.length > 0) {
        this.setState({ dossiers: this.props.dossiers })
      }
      this.setState({ numDossiers: dossiers.length, typeChanged: false })
    }

    if (
      this.props.fleet &&
      !this.props.create &&
      ((this.props.tabActiveKey !== prevProps.tabActiveKey && this.props.tabActiveKey === fleetsTab.FLEETS_DOCUMENTS && this.state.openDocumentPanel) ||
      (this.props.tabActiveKey === fleetsTab.FLEETS_DOCUMENTS && this.state.openDocumentPanel && this.state.openDocumentPanel !== prevState.openDocumentPanel) ||
      (this.props.tabActiveKey === fleetsTab.FLEETS_DOCUMENTS && this.state.openDocumentPanel && this.props.dossiers !== prevProps.dossiers))) {
      this.updateList(this.props.dossierTypeSelected)
      this.props.change('dossierSubType', this.props.dossierTypeSelected)
    }
  }

  updateList (dossierTypeSelected, changeType = false) {
    switch (dossierTypeSelected) {
      case dossierTypeIdsConstant.sales:
        if (this.props.dossiers && this.props.dossiers.length > 0 && !changeType) {
          this.props.actions.getDocumentFleetList(null, this.props.dossiers)
          this.setState({ numDossiers: this.props.dossiers.length, dossiers: this.props.dossiers })
        } else {
          new Promise((resolve) => {
            this.props.actions.getDossierDetailsFleet(this.props.fleet.fleetId, resolve)
          }).then((response) => {
            this.props.actions.getDocumentFleetList(null, response.map(dossier => dossier.dossierId))
            this.setState({ numDossiers: response.length, dossiers: response.map(dossier => dossier.dossierId) })
            this.props.documentsAllSelected(true)
          })
        }
        break
      case dossierTypeIdsConstant.paperwork:
        if (this.props.dossiers && this.props.dossiers.length > 0 && !changeType) {
          this.props.actions.getDocumentFleetList(null, this.props.dossiers)
          this.setState({ numDossiers: this.props.dossiers.length, dossiers: this.props.dossiers })
        } else {
          new Promise((resolve) => {
            this.props.actions.getPaperworksDetailsFleet(this.props.fleet.fleetId, resolve)
          }).then((response) => {
            this.props.actions.getDocumentFleetList(null, response.map(dossier => dossier.dossierId))
            this.setState({ numDossiers: response.length, dossiers: response.map(dossier => dossier.dossierId) })
            this.props.documentsAllSelected(true)
          })
        }
        break
      case dossierTypeIdsConstant.purchase:
        if (this.props.dossiers && this.props.dossiers.length > 0 && !changeType) {
          this.props.actions.getDocumentFleetList(null, this.props.dossiers)
          this.setState({ numDossiers: this.props.dossiers.length, dossiers: this.props.dossiers })
        } else {
          new Promise((resolve) => {
            this.props.actions.getPurchasesDetailsFleet(this.props.fleet.fleetId, resolve)
          }).then((response) => {
            this.props.actions.getDocumentFleetList(null, response.map(dossier => dossier.dossierId))
            this.setState({ numDossiers: response.length, dossiers: response.map(dossier => dossier.dossierId) })
            this.props.documentsAllSelected(true)
          })
        }
        break
      default:
        break
    }
  }

  addDocument () {
    let dossiers = this.props.dossiers.length > 0 ? this.props.dossiers : this.state.dossiers

    this.props.actions.openDocumentCreationModal(null, documentEntityTypeConstants.DOSSIER, this.props.fleet.organizedUnitId, null, null, null, true,
      this.props.fleet.dossierSubType, null, null, null, fleetMode.INCORPORATE_OTHER_DOCUMENTS, this.props.fleet?.fleetId, dossiers)
  }

  collapsePanelDocuments () {
    this.setState({ openDocumentPanel: !this.state.openDocumentPanel })
  }

  getSnapshotBeforeUpdate (prevProps) {
    return null
  }

  getIconClass (field) {
    if (this.state.filters.orderBy.includes(field)) {
      return this.state.filters.orderBy.includes('-') ? 'ico-sort-selected-asc' : 'ico-sort-selected-desc'
    } else {
      return 'ico-sort'
    }
  }

  onOrderChange (e) {
    const newOrderBy = this.state.filters.orderBy.includes(`+${e.currentTarget.dataset.field}`) ? `-${e.currentTarget.dataset.field}` : `+${e.currentTarget.dataset.field}`
    this.setState({ filters: { orderBy: newOrderBy } })
    this.order(e.currentTarget.dataset.field, newOrderBy.includes('+') ? 'asc' : 'desc')
  }

  order (field, order) {
    let documents = JSON.parse(JSON.stringify(this.props.documentsFleetList))
    documents = documents.sort(compareValues(field, order))
    this.props.actions.getDocumentFleetListSuccess(documents)
  }

  detailDocument (document) {
    this.props.actions.openDocumentDetailsFleetModal(this.props.fleet, document, this.state.dossiers, this.props.dossiersMode)
  }

  selectAll () {
    this.props.actions.openDocumentFleetModal(this.props.fleet, true, [])
    this.props.documentsAllSelected(true)
  }

  modify () {
    this.props.moveToModifyDocumentsSelection(this.props.dossierTypeSelected)
  }

  handleDossierTypeChange (val) {
    this.props.changeDossierTypeSelected(val)
    this.setState({ typeChanged: true })
    this.updateList(val, true)
  }

  getTotalDossierByType () {
    switch (this.props.dossierTypeSelected) {
      case dossierTypeIdsConstant.sales:
        return this.props.dossierFleetDetails ? this.props.dossierFleetDetails.length : 0
      case dossierTypeIdsConstant.paperwork:
        return this.props.paperWorkCount
      case dossierTypeIdsConstant.purchase:
        return this.props.purchaseFleetDetails ? this.props.purchaseFleetDetails.length : 0
      default:
        return 0
    }
  }

  render () {
    const {
      t,
      documentsFleetList,
      dossierTypesCombo,
      dossiers
    } = this.props
    const tKey = 'MANAGEMENT.FLEETS_TAB.'
    let subTitle = t(`${tKey}NUM_SELECTED_DOSSIERS`)
      .replace('##NUM_SELECTED##', this.state.numDossiers)
      .replace('##NUM_TOTAL##', this.getTotalDossierByType())
    let bar = ' | '

    return (
      <div id='documentsListComponent'>
        <div className="flexInLine al-R marg-bottom-15">
          {this.props?.fieldsConfiguration?.addOtherDocumentsFleet && this.props?.fieldsConfiguration?.addOtherDocumentsFleet?.permission === permissions.editable &&
          (dossiers.length > 0 || this.state.dossiers.length > 0) && (
            <Button
              id="documentListComponente_addDocument_button"
              className="_Btn accept"
              onClick = {() => this.addDocument()}>
              {t('MANAGEMENT.ADMIN_AUDIT.MODAL.ADD_DOCUMENT')}
            </Button>)}
        </div>
        <div className="dossier-panel" >
          <div className="header-panel  fleet-panel-box" onClick={() => this.collapsePanelDocuments()}>

            <div className="name-wrapper fleet-panel-box-title">
              <h4>{t(`${tKey}DOCUMENTS`)}{bar}<span className='fleet-panel-subTitle'>{subTitle}</span></h4>
            </div>

            <i className={this.state.openDocumentPanel ? 'ico-arrow-black-down fleet-panel-box-caret' : 'ico-arrow-black-up fleet-panel-box-caret'} />

          </div>
          <Panel expanded={this.state.openDocumentPanel} onToggle={() => {}}>
            <Panel.Collapse>
              <div id="fleet-dossier-details-table" className='_nf'>
                <div className="actionsLine">
                  <Field
                    component={InputSelect}
                    colWidth={0}
                    id="fleets_dossierSubTypeId"
                    name='dossierSubType'
                    placeholder={t(`${tKey}DOSSIER_SUBTYPE`)}
                    controlLabel={t(`${tKey}DOSSIER_SUBTYPE`)}
                    options={dossierTypesCombo.filter(dossierType => this.dossierTypeOptions.includes(dossierType.id))}
                    valueKey="id"
                    labelKey="value"
                    onInputChange={(val) => this.handleDossierTypeChange(val)}
                  />

                  <Button
                    id="documentListComponent_checkAll_button"
                    className="_Btn accept stk"
                    onClick = {() => this.selectAll()}
                    disabled={this.props.allSelected}>
                    {t('MANAGEMENT.FLEETS_TAB.CHECK_ALL')}
                  </Button>
                  <Button
                    id="documentListComponent_modifySelection_button"
                    className="_Btn accept stk"
                    onClick = {() => this.modify()}>
                    {t('MANAGEMENT.FLEETS_TAB.MODIFY_SELECTION')}
                  </Button>
                  <Button
                    id="documentListComponent_refresh_button"
                    className="_Btn accept stk"
                    onClick = {() => this.updateList(this.props.dossierTypeSelected, this.state.typeChanged)}>
                    {t('MANAGEMENT.FLEETS_TAB.REFRESH')}
                  </Button>
                </div>
                <SimpleTablePage
                  columns={[
                    <th key={0} data-field="documentTypeUseId" style={{ display: 'none' }}>
                    </th>,
                    <th key={1} data-field="description" onClick={(event) => this.onOrderChange(event)}>
                      {t(`${tKey}DOCUMENT`)}&nbsp;<i className={this.getIconClass('description')}></i>
                    </th>,
                    <th key={2} data-field="category" onClick={(event) => this.onOrderChange(event)}>
                      {t(`${tKey}CATEGORY`)}&nbsp;<i className={this.getIconClass('category')}/>
                    </th>,
                    <th key={3} data-field="requested" onClick={(event) => this.onOrderChange(event)}>
                      {t(`${tKey}REQUESTED`)}&nbsp;<i className={this.getIconClass('requested')}></i>
                    </th>,
                    <th key={4} data-field="incorporated" onClick={(event) => this.onOrderChange(event)}>
                      {t(`${tKey}INCORPORATED`)}&nbsp;<i className={this.getIconClass('incorporated')}/>
                    </th>,
                    <th key={5} data-field="validated" onClick={(event) => this.onOrderChange(event)}>
                      {t(`${tKey}VALIDATED`)}&nbsp;<i className={this.getIconClass('validated')}/>
                    </th>,
                    <th key={6} data-field="signRequested" onClick={(event) => this.onOrderChange(event)}>
                      {t(`${tKey}SIGN_REQUESTED`)}&nbsp;<i className={this.getIconClass('signRequested')}/>
                    </th>,
                    <th key={7} data-field="signed" onClick={(event) => this.onOrderChange(event)}>
                      {t(`${tKey}SIGNED`)}&nbsp;<i className={this.getIconClass('signed')}/>
                    </th>,
                    <th key={8} data-field="rejected" onClick={(event) => this.onOrderChange(event)}>
                      {t(`${tKey}REJECTED`)}&nbsp;<i className={this.getIconClass('rejected')}/>
                    </th>,
                    <th key={9} data-field="detail" className='flet-detail-dossier-check-title' >
                      {t(`${tKey}DETAIL`)}&nbsp;<i className={this.getIconClass('detail')}/>
                    </th>
                  ]}
                  rows={documentsFleetList && documentsFleetList.map((row, idx) => (
                    <tr key={idx}>
                      <td>{row.description}</td>
                      <td>{row.category}</td>
                      <td className='number-column'>{row.requested}</td>
                      <td className='number-column'>{row.incorporated}</td>
                      <td className='number-column'>{row.validated}</td>
                      <td className='number-column'>{row.signRequested}</td>
                      <td className='number-column'>{row.signed}</td>
                      <td className='number-column'>{row.rejected}</td>
                      <td>{
                        <a onClick={() => this.detailDocument(row)}>
                          <Glyphicon className='icon-action blue' glyph="eye-open"/>
                        </a>
                      }
                      </td>
                    </tr>
                  ))}

                ></SimpleTablePage>
              </div>

            </Panel.Collapse>
          </Panel>
        </div>
        <DocumentDetailsFleetModalPage getDocumentFleetList={() => this.updateList(this.props.dossierTypeSelected)}></DocumentDetailsFleetModalPage>
      </div>
    )
  }
}

export default reduxForm({
  form: 'DocumentsListComponent'
})(DocumentsListComponent)
